export default __webpack_public_path__ + "static/media/copy.87776f6f.svg";